// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__D1u7R","text":"Footer_text__xAks7","image":"Footer_image__lEv1h"};